import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SSITruncatedTextStyled, SSITruncatedContainerStyled, SSITruncatedFullTextStyled } from '../../../styles/components/components/SSIText';
const SSIText = (props) => {
    const { value, truncationLength } = props;
    if (truncationLength && value.length > truncationLength) {
        const truncatedText = value.substring(0, truncationLength);
        return (_jsxs(SSITruncatedContainerStyled, { children: [_jsx(SSITruncatedTextStyled, { children: truncatedText }), _jsx(SSITruncatedFullTextStyled, { children: value })] }));
    }
    else {
        return _jsx("p", { children: value });
    }
};
export default SSIText;
